export default __webpack_public_path__ + "adad7ad05bdab89f8931b47346de6038.png";